/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace */

import { Project }                    from './project';
import { ProjectType }                from "@/models/project.type";
import { ProjectElement       }       from './project/project.element';
import { SimulationElement    }       from './project/simulation.element';
import { LocomotiveModelElement }     from '@/models/project/locomotive.model.element';
import { OperationalMeasuresElement } from '@/models/project/operational.measures.element';
import { ProjectFactoryDecorator }    from "@/models/project.factory.decorator";

/**
 *
 * @class BatchSimulationProject
 *
 * @brief this project is for a NxN input to output "batch simulations".
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2020
 *
 */
@ProjectFactoryDecorator('BatchSimulationProject')
export class BatchSimulationProject extends Project {

  /** standard constructor */
  constructor(name: string) {

    super(name, 'fas fa-cubes');

    this.type  = ProjectType.BatchSimulation;
    this.icon  = '<i class="fas fa-cubes"></i>';
    this.facon = 'fas fa-cubes';

    /* build up default structure */

    const a:    ProjectElement = new SimulationElement(this, '', this.root());
    const b:    ProjectElement = new LocomotiveModelElement(this, '', this.root());
    const c:    ProjectElement = new OperationalMeasuresElement(this, '', this.root());
  }

  /** helper to use to for static global constructors (and factory registration) */
  static requireType() {
    console.log("requiring BatchSimulationProject");
  }

}
